import styled from "styled-components";

export const ListaContrato = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContratoDisponivelButtonContainer = styled.div`
  display: inline-block;
  width: 100%;
  margin: 10px;

  @media (min-width: 768px) {
    width: 350px;
  }
`;

export const ContratoDisponivelButton = styled.button <any>`
  width: 100%;
  border: 1px solid #109BCB;
  border-radius: 5px;
  background: #FFFFFF;
  color: $#109BCB;
  padding: 5px;
  text-align: center;
  transition: 0.9s;

  &:hover {
    background: #109BCB;
    color: #FFFFFF;
    cursor: pointer;
  }

  @media (min-width: 768px) {
    width: 350px;
  }
`;
